import { Injectable, EventEmitter, Optional, OnDestroy, Inject } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

@Injectable()
export class QueryParams implements OnDestroy {

  public static DEFAULTS: string = 'queryParamsDefaults';

  public page: number;
  public limit: number;
  public first: number;

  public defaults: { [key: string]: any } = {};
  public params: { [key: string]: any } = {};
  public onChange: EventEmitter<any> = new EventEmitter<any>();
  private routeSubscription: Subscription;
  private currentUrlParams: any = {};

  private baseDefaults: { [key: string]: any } = {
    page: 1,
    limit: 10
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    @Inject(QueryParams.DEFAULTS)
    @Optional()
    defaults: any
  ) {
    let queryParamsContainDefaults: boolean = false;

    defaults = defaults || {};

    for (let paramKey in activatedRoute.snapshot.queryParams) {
      if (!activatedRoute.snapshot.queryParams.hasOwnProperty(paramKey)) {
        continue;
      }

      let paramValue = activatedRoute.snapshot.queryParams[paramKey];

      if (
        defaults.hasOwnProperty(paramKey) &&
        defaults[paramKey] === paramValue
      ) {
        queryParamsContainDefaults = true;
        continue;
      }

      this.currentUrlParams[paramKey] = paramValue;
    }

    if (queryParamsContainDefaults) {
      this.router.navigate([], {
        queryParams: this.currentUrlParams,
        relativeTo: activatedRoute,
        replaceUrl: true
      })
      .then(() => {
        this.watchQueryParams();
      });
    }

    this.init(defaults, !queryParamsContainDefaults);
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }

  public setParam(name: string, value: any, updateParams: boolean = true) {
    this.params[name] = value;

    if (
      this.defaults.hasOwnProperty(name) &&
      this.defaults[name] == value
    ) {
      delete this.params[name];
    }

    if (updateParams) {
      this.updateUrlParams();
      this.updatePublicParams();
    }
  }

  public isDefaultParam(name: string): boolean {
    if (!this.defaults.hasOwnProperty(name)) {
      return false;
    }

    return !this.params.hasOwnProperty(name);
  }

  public unsetParam(name: string, unsetDefaults: boolean = false) {
    if (this.params.hasOwnProperty(name)) {
      delete this.params[name];
    }

    if (unsetDefaults && this.defaults.hasOwnProperty(name)) {
      delete this.defaults[name];
    }

    this.updateUrlParams();
    this.updatePublicParams();
  }

  public getParam(name: string): any {
    if (this.params.hasOwnProperty(name)) {
      return this.params[name];
    }

    if (this.defaults.hasOwnProperty(name)) {
      return this.defaults[name];
    }

    return null;
  }

  public getURLSearchParams(): URLSearchParams {
    let params: URLSearchParams = new URLSearchParams();

    for (let key in this.defaults) {
      if (this.defaults.hasOwnProperty(key)) {
        params.set(key, this.defaults[key]);
      }
    }

    for (let key in this.params) {
      if (this.params.hasOwnProperty(key)) {
        params.set(key, this.params[key]);
      }
    }

    return params;
  }

  private init(defaults, runListener: boolean) {
    this.overwriteParams(this.currentUrlParams);
    this.setDefaults(defaults);

    if (runListener) {
      this.watchQueryParams();
    }
  }

  private watchQueryParams() {
    this.routeSubscription = this.activatedRoute.queryParams.subscribe((params: any) => {
      this.currentUrlParams = params;
      this.overwriteParams(params);
      this.onChange.emit(null);
    });
  }

  private setDefaults(defaults: { [key: string]: any }) {
    this.defaults = this.baseDefaults;

    for (let key in defaults) {
      if (!defaults.hasOwnProperty(key)) {
        continue;
      }

      if (
        this.params.hasOwnProperty(key) &&
        this.params[key] == defaults[key]
      ) {
        delete this.params[key];
      }

      this.defaults[key] = defaults[key];
    }

    this.updateUrlParams();
    this.updatePublicParams();
  }

  private overwriteParams(params: { [key: string]: any }) {
    this.params = {};

    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        this.setParam(key, params[key], false);
      }
    }

    this.updateUrlParams();
    this.updatePublicParams();
  }

  private updateUrlParams() {
    if (!this.queryParamsChanged()) {
      return;
    }

    this.router.navigate(
      [],
      {
        queryParams: this.params,
        relativeTo: this.activatedRoute
      }
    );
  }

  private updatePublicParams() {
    let pageParam: any = this.getParam('page');
    let limitParam: any = this.getParam('limit');

    if (null === pageParam) {
      this.page = 1;
    } else {
      this.page = +pageParam;
    }

    if (null === limitParam) {
      this.limit = 1;
    } else {
      this.limit = +limitParam;
    }

    this.first = (this.page - 1) * this.limit;
  }

  private queryParamsChanged(): boolean {
    let currentParamsKeys: Array<string> = Object.keys(this.currentUrlParams);
    let newParamsKeys: Array<string> = Object.keys(this.params);

    if (currentParamsKeys.length !== newParamsKeys.length) {
      return true;
    }

    for (let paramName of currentParamsKeys) {
      if (this.currentUrlParams[paramName] !== this.params[paramName]) {
        return true;
      }
    }

    return false;
  }

}



// WEBPACK FOOTER //
// /dist/src/app/shared/grid/grid-params.ts